import * as yup from 'yup';

export const feedbackSchema : any = yup.object().shape({
  subject: yup.string().required('Subject Required'),
  description: yup.string(),
  // description: yup.string().required('Description Required')
});
